import { getApiClient } from './ApiClient'

export const mealIngredientPreparationListPromise = (params) => {
  return getApiClient()
    .get('/meal-ingredient/preparations', {
      params
    })
    .then(resp => {
      return Promise.resolve(resp.data)
    })
}

export const mealIngredientPreparationDetailPromise = (id) => {
  return getApiClient()
    .get(`/meal-ingredient/preparations/${id}`)
    .then(resp => {
      return Promise.resolve(resp.data)
    })
}

export const mealIngredientPreparationUpsertPromise = (body) => {
  return getApiClient()
    .post('/meal-ingredient/preparations/upsert', {
      body
    })
    .then(resp => {
      return Promise.resolve(resp.data)
    })
}
